import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import {
  Box,
  Checkbox,
  FormControlLabel,
  Radio,
  Stack,
  Typography,
  CircularProgress,
} from "@mui/material";
import axios from "axios";
import { useDispatch } from "react-redux";
import {
  setExamResultsArr,
  setIsGraded,
  setTutorPass,
  setTutorResult,
} from "../../../../../redux/slice/tutorExamSlice";
import { FidgetSpinner } from "react-loader-spinner";
import Loader from "./loader/Loader";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function AnswerModal({ data, open, handleClose }) {
  const [marked, setMarked] = React.useState("");
  const [totalMarks, setTotalMarks] = React.useState(0);
  const [loading, setLoading] = React.useState(false);
  const [secondDialogOpen, setSecondDialogOpen] = React.useState(false);

  const dispatch = useDispatch();

  const handleClickSecondOpen = (e) => {
    if (totalMarks < 0 || totalMarks > 100 || !marked) {
      alert("Please mark status and enter marks(0 to 100)");
      return;
    }
    setSecondDialogOpen(true);
  };
  const handleSecondClose = () => {
    setSecondDialogOpen(false);
  };

  const handleKeyDown = (event, val) => {
    if (event.key === "Enter") {
      // Prevent the default action of the Enter key
      event.preventDefault();
      // Optionally, you can call another function here if needed
      // For now, just updating the totalMarks state without API call
      setTotalMarks(val);
    }
  };

  const handleRadioChange = (value) => {
    setMarked(value);
  };

  console.log(totalMarks, "<><>><<>>>");

  const sendSubjectiveGrade = React.useCallback(async () => {
    setLoading(true);
    try {
      const response = await axios.put(
        //  "http://localhost:8600/api/tutorWeb/grade-subjective-question",
        "https://testapis4.el.r.appspot.com/api/tutorWeb/grade-subjective-question",
        {
          tutorId: data.doerId,
          examId: data.examId,
          marks: totalMarks,
          status: marked,
          uniqueId: data.uniqueId,
        }
      );

      if (response.status === 200 || response.status === 201) {
        alert("Result Updated");
        handleClose();
        if (response?.data?.data) {
          dispatch(setTutorResult(response?.data?.data));
          dispatch(setExamResultsArr(response?.data?.data));
        }
        dispatch(setIsGraded());
        // setLoading(false);
      }
      setLoading(false);
    } catch (error) {
      alert("Some error occured. Please try after some time.");
      console.log(error);
      setLoading(false);
    }
  }, [handleClose, dispatch, data, totalMarks, marked]);

  return (
    <React.Fragment>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Answer and Response</DialogTitle>
        <DialogContent
          sx={{
            borderBottomWidth: "1px",
            padding: "0",
          }}
        >
          {/* Display questions and answers */}
          <Box
            mt={1}
            sx={{
              padding: "10px 25px",
            }}
          >
            {data.questions.map((question, index) => (
              <Box
                sx={{
                  marginBottom: "8px",
                }}
                key={index}
              >
                <Typography
                  sx={{
                    fontFamily: "Poppins",
                    fontWeight: 500,
                    color: "#000000",
                    marginBottom: "5px",
                  }}
                >
                  Question:{index + 1}){" "}
                  <strong className="text-sm">{question}</strong>
                </Typography>
                <Box sx={{ marginBottom: "20px", marginLeft: "8px" }}>
                  <Typography
                    sx={{
                      fontFamily: "Poppins",
                      fontWeight: 300,
                      color: "gray",
                      fontSize: "12px",
                      lineHeight: "24px",
                      borderBottomWidth: "1px",
                      borderBottomStyle: "dotted",
                      marginTop: "15px",
                    }}
                  >
                    <span className="font-medium text-black text-sm">
                      Answer:
                    </span>{" "}
                    &nbsp;
                    <span className="text-[13px] font-[400] text-black">
                      {data.answerResponses[index]
                        ? data.answerResponses[index]
                        : "Answer not provided"}
                    </span>
                  </Typography>
                  <Box>
                    <Stack gap={2}>
                      <Typography
                        sx={{
                          fontFamily: "Poppins",
                          fontWeight: 300,
                          color: "gray",
                          fontSize: "13px",
                          marginTop: "5px",
                        }}
                      >
                        <span className="font-medium text-black text-sm">
                          Supporting Files:
                        </span>{" "}
                        &nbsp;
                        {data.googleFileLinks[index] &&
                        data.googleFileLinks[index].length > 0
                          ? data.googleFileLinks[index].map(
                              (file, fileIndex) => (
                                <React.Fragment key={fileIndex}>
                                  <a
                                    href={file}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-blue-500"
                                  >
                                    {`File ${fileIndex + 1}`}
                                  </a>
                                  {fileIndex !==
                                    data.googleFileLinks[index].length - 1 &&
                                    ", "}
                                </React.Fragment>
                              )
                            )
                          : "NO FILES PROVIDED"}
                      </Typography>
                    </Stack>
                  </Box>
                </Box>
              </Box>
            ))}
          </Box>
          {/* Marking options */}

          <Box
            mb={2}
            sx={{
              borderTopWidth: "1px",
              padding: "15px 20px",
            }}
          >
            <Box>
              <label>Insert Mark</label>
              <input
                className="border border-black outline-none py-2 px-3 rounded"
                placeholder="enter marks"
                value={totalMarks}
                type="number"
                onChange={(e) => setTotalMarks(parseInt(e.target.value))}
                onKeyDown={handleKeyDown}
              />

              <Box mt={2}>
                <Stack flexDirection="row" alignItems="center" gap={2}>
                  <FormControlLabel
                    label="Mark Pass"
                    control={
                      <Radio
                        checked={marked === "pass"}
                        onChange={() => handleRadioChange("pass")}
                      />
                    }
                  />
                  <FormControlLabel
                    label="Mark Fail"
                    control={
                      <Radio
                        checked={marked === "fail"}
                        onChange={() => handleRadioChange("fail")}
                      />
                    }
                  />
                </Stack>
              </Box>
            </Box>
          </Box>
        </DialogContent>
        {/* Submit button */}
        <DialogActions>
          <Button onClick={handleClickSecondOpen} variant="outlined">
            Submit
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={secondDialogOpen}
        onClose={handleSecondClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {`Marks ${totalMarks} and status ${marked} cannot be changed, so please only submit if you are certain.`}
        </DialogTitle>
        <DialogActions>
          <Button onClick={handleSecondClose}>Cancel</Button>
          <Button onClick={sendSubjectiveGrade} autoFocus>
            {loading && (
              <CircularProgress
                style={{
                  width: "22px",
                  height: "22px",
                  marginLeft: "5px",
                }}
                color="inherit"
              />
            )}
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
